import React from 'react';
import Headtitle from "../../Components/HeadTitle/Headtitle";
import All_Testim from './All_Testim';

import "./Testimonial.scss";

function Testimonial() {
  return (
    <>
    <Headtitle/>
    <All_Testim/>
    </>
  )
}

export default Testimonial;